export default __webpack_public_path__ + "static/media/13.3ed4bd21.png";